(function() {
  'use strict';

  angular
    .module('traineeWebApp.handout')
    .controller('HandoutCtrl', HandoutCtrl);

  HandoutCtrl.$inject = ['$scope', '$timeout', 'Utils', 'handoutResource'];

  function HandoutCtrl($scope, $timeout, Utils, handoutResource) {
    var iconFileTypeMap = {
      'pdf': 'icon-pdf',
      'doc': 'icon-doc',
      'docx': 'icon-doc',
      'xls': 'icon-xls',
      'xlsx': 'icon-xls',
      'ppt': 'icon-ppt',
      'pptx': 'icon-ppt',
      'png': 'icon-png',
      'default': 'icon-general'
    };

    $scope.hasHandouts = function(cModule) {
      return cModule && cModule.handouts && cModule.handouts.length > 0;
    };

    $scope.handoutIconClass = function(fileType) {
      return iconFileTypeMap[fileType.toLowerCase()] || iconFileTypeMap.default;
    };

    $scope.downloadHandout = function(contentFileId) {
      handoutResource.getHandoutDownloadURL(contentFileId, function(res) {
        $timeout(function() {
          Utils.download(res.url);
        });
      });
    };
  }
})();
